import { FormEvent, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Logo } from "../components/Logo";
import { Spinner } from "../components/Spinner";

export function Login() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/dashboard";
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try { await login(email, pw); nav(next); }
    catch (e: any) { setErr(humanError(e?.message)); }
    finally { setLoading(false); }
  }

  return (
    <div className="mx-auto grid min-h-[80vh] max-w-md place-items-center px-4">
      <div className="w-full">
        <div className="mb-6 flex items-center gap-2 text-white/90"><Logo className="h-6 w-6" /><span className="font-semibold">Motion</span></div>
        <h1 className="text-2xl font-semibold tracking-tight text-white">Welcome back</h1>
        <p className="text-sm text-white/50">Pick up where you left off.</p>
        <form className="mt-6 space-y-3" onSubmit={onSubmit}>
          <label className="block">
            <span className="mb-1 block text-xs text-white/60">Email</span>
            <input className="field" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label className="block">
            <span className="mb-1 block text-xs text-white/60">Password</span>
            <input className="field" type="password" autoComplete="current-password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} />
          </label>
          {err && <div className="rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-300">{err}</div>}
          <button className="btn-primary w-full py-2.5" disabled={loading} type="submit">
            {loading ? <Spinner /> : "Log in"}
          </button>
        </form>
        <p className="mt-4 text-sm text-white/50">
          New here? <Link to="/signup" className="text-white underline-offset-2 hover:underline">Create an account</Link>.
        </p>
      </div>
    </div>
  );
}

function humanError(code?: string) {
  if (code === "invalid_credentials") return "That email and password don’t match.";
  if (code === "rate_limited") return "Too many attempts. Wait a minute and try again.";
  return code ?? "Something went wrong. Try again.";
}
